import { report } from 'report';
import { IGameState } from 'State/Game/IGameState';
import { resetEventHandlerData, track } from '../Track';
import { UserEventName } from '../TrackingEvent';

export const trackUserUnification = (state: IGameState, formerUserID: string, newUserID: string) => {
    try {
        if (!formerUserID) {
            reportError('FormerUserId missing', 'trackUserUnification:MissingFormerUserId');
        }

        if (!newUserID) {
            reportError('NewUserId missing', 'trackUserUnification:MissingNewUserId');
        }

        if (newUserID === formerUserID) {
            reportError('UserUnification: UserId is unchanged', 'trackUserUnification:UnchangedUserId');
        }

        track('userID', newUserID);
        track('newUserID', newUserID);
        track('formerUserID', formerUserID);
        // Send event for new user / save data
        resetEventHandlerData(UserEventName.userUnification, state);
    } catch (error) {
        report('Failed to track user unification event', {
            error,
            once: true,
            sampleRate: 0.5,
            fingerprint: 'trackUserUnification',
        });
    }
    return;

    function reportError(message: string, fingerprint: string): void {
        report(message, {
            once: true,
            sampleRate: 0.1,
            fingerprint,
            tags: {
                formerUserID,
                newUserID,
            },
            state,
        });
    }
};
